import React, { useState, useEffect, Fragment } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Profile from '../components/profile';
import homeImage from '../images/home.jpeg';
import logoMatador from '../images/logo-matador.png';
import { marcaPresentador } from '../functions/presentador';
export default function Home() {

    const [profileInfo, setProfileInfo] = useState({
        username: '',
        average: 0.00,
        wines: 0,
        profile: 0,
        id: 0
    });

    
    const [profileReload, setProfileReload] = useState(false); // Nuevo estado en Home
    const navigate = useNavigate();

    useEffect(() => {
        // Cargar la información del usuario desde localStorage
        const storedUserInfo = localStorage.getItem('userLogged');
        if (storedUserInfo) {
            const userInfo = JSON.parse(storedUserInfo);
            console.log(userInfo);
            setProfileInfo({
                username: userInfo.username,
                average: userInfo.average || 0.00,
                wines: userInfo.wines || 0,
                id: userInfo.id || 0,
                winegang: userInfo.winegang || null,
                profile: userInfo.profile || 'default'
            });
            fetchUserData(userInfo);
        }
    }, []);

    const fetchUserData = (userInfo) => {
        const xhr = new XMLHttpRequest();
        const url = `${process.env.REACT_APP_API_URL}/userlog/${userInfo.id}`;
        xhr.open("GET", url, true);
        xhr.onreadystatechange = () => {
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    const data = JSON.parse(xhr.responseText);
                    // Verificar si el email recibido coincide con el guardado
                    if (data.email === userInfo.email) {
                        const updatedUserInfo = {
                            ...userInfo,
                            average: data.average,
                            wines: data.wines,
                            username: data.username,
                            winegang: data.winegang,
                            presentador: marcaPresentador(data) // sin volver a entrar
                        };
                        localStorage.setItem('userLogged', JSON.stringify(updatedUserInfo));
                        setProfileInfo(updatedUserInfo);
                        setProfileReload(prev => !prev);
                        
                    } else {
                        // Si no coincide, elimina userLogged de localStorage y redirige al login
                        localStorage.removeItem('userLogged');
                        navigate('/login');
                    }
                } else {
                        // Si no coincide, elimina userLogged de localStorage y redirige al login
                        localStorage.removeItem('userLogged');
                        navigate('/login');
                    }
            }
        };
        xhr.send();
    };
    const winegangLink =
    profileInfo.winegang && profileInfo.winegang.id
        ? `/gangs/${profileInfo.winegang.id}`
        : '/gangs';


  return (
      <div className="home">
          <Profile profileReload={profileReload} />
        <h1 className="home-title red">
            <img src={logoMatador} alt="Club Matador" className="home-logo" />
        </h1>
        <div className="home-image-container">
            <img src={homeImage} alt="Imagen home" className="home-image" />
        </div>
      <div className="button-container">
              
              <button className="main-button"><Link to="/choose-wine">JUGAR</Link></button>
              <button className="corner-button top-right"><Link to="/ranking-gangs">CLASIFICACIÓN</Link></button>
              <button className="corner-button top-left"><Link to={winegangLink}>EQUIPO</Link></button>
              
      </div>
    </div>
  
  )
}
